module.exports = __webpack_public_path__ + "6add0a5e2e80efbbd583d8b2853ca1ed.svg";